import React, { useEffect, useRef, useState } from "react";
import "./ChatPage.css";
import CompanionLogo from "../../assets/comapionlogo.png";
import SendIcon from "../../assets/send.png";
import chatIcon from "../../assets/chaticon.png";
import StopGenerating from "../../assets/stopgeneratingicon.png";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";
import axios from "axios";
import MessageCard from "./Message";
import InitialMessageSection from "./InitialMessageSection";
import { Loader } from "../../utils/util";
import {
  fetchArchiveChat,
  getChatConversation,
  getConvo,
  updateMessageLikeStatus,
} from "../../api/Service";
import { useChatContext } from "../../../../context";
import { Spinner } from "../../../web-workflow/common/Helper";
import MessageLoader from "./MessageLoader";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import axiosInstance from "../../../../axiosInterceptor";

function ChatPage() {
  const messagesRef = useRef(null);
  const { common, chatAI, scroll } = useChatContext();
  const {
    conversations,
    setConversations,
    activeConversation,
    setActiveConversation,
    messages,
    setMessages,
    selectedModal,
    setSelectedModal,
    isFirstMesssge,
    setIsFirstMessage,
    archivedChats,
    setArchivedChats,
    isMessagesLoading,
    setIsMessagesLoading,
  } = chatAI;
  const {
    isConversationsLoading,
    setIsConversationsLoading,
    hasMoreConversations,
    setHasMoreConversations,
    currentPage,
    setCurrentPage,
  } = scroll;
  const { mode } = common;
  const [isOpen, setIsOpen] = useState(false);
  const [messageInput, setMessageInput] = useState("");
  const [error, setError] = useState("");
  const [stopGenerating, setStopGenerating] = useState(false);
  const [abortController, setAbortController] = useState(null);
  const [isMessageLoading, setIsMessageLoading] = useState(false);
  const [isPrevMessagesLoading, setIsPrevMessagesLoading] = useState(false);
  const [hasPrevMessages, setHasPrevMessages] = useState(true);
  const [prevMszPageNumber, setPrevMszPageNumber] = useState(1);
  const inifinteWrapperClassName = ".chat-infinte-scroll";

  const scrollToBottomFn = (prevHeight = 0) => {
    setTimeout(() => {
      const el = document.querySelector(inifinteWrapperClassName);
      if (el) {
        const { scrollHeight } = el;
        el.scrollTop = scrollHeight - prevHeight;
      }
    }, 0);
  };

  const getConversations = async (pageNum, loadMore) => {
    try {
      setIsConversationsLoading(true);
      const messages = await getConvo(pageNum);
      if (loadMore) {
        setConversations([...conversations, ...messages]);
      } else {
        setConversations(messages);
      }
      setHasMoreConversations(true);
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      return messages;
    } catch (err) {
      console.error("get_convo_error:::", err.message);
      setHasMoreConversations(false);
      if (!loadMore) {
        setConversations([]);
      }
    } finally {
      setIsConversationsLoading(false);
    }
  };
  useEffect(() => {
    getConversations(1);
  }, []);

  const handleMessageInputChange = (event) => {
    setMessageInput(event.target.value);
  };

  const uploadConversationMessage = async (payload) => {
    const { session_token, conversation_id, newMessage } = payload;
    const endPoint =
      "https://3fm7fqule5.execute-api.ap-southeast-2.amazonaws.com/llm_post_message/";
    axiosInstance
      .post(endPoint, {
        body: {
          session_token,
          conversation_id,
          message_sent: newMessage.question,
          answer_recieved: {
            answer: newMessage.answer.answer,
            contents_list: newMessage.answer.contents_list,
          },
        },
      })
      .then((data) => {
        console.log("CONVO UPLOADED SUCCES::", data.data.body, messages);
        const messageRes = JSON.parse(data.data.body);
        setMessages([
          ...messages,
          { ...newMessage, message_id: messageRes.message_id },
        ]);
        scrollToBottomFn(0)
      })
      .catch((err) => {
        console.log("CONVO UPLOAD FAIL:::", err.message);
      });
  };
  const sendMessage = (input) => {
    const question = input ? input : messageInput;
    if (!question) return;
    setStopGenerating(true);
    const controller = new AbortController();
    setAbortController(controller);
    const accessToken = sessionStorage.getItem("accessToken");
    const newMessage = { question, response: null };
    console.log(newMessage, "newmsz:::");
    setMessages([...messages, newMessage]);
    setIsMessageLoading(true);
    setMessageInput("");
    const token = sessionStorage.getItem('accessToken'); 
    // https://jq710hhiek.execute-api.us-west-2.amazonaws.com/dev/
    const url =
      selectedModal === "VERSION_1"
        ? "https://qi79lwqmtb.execute-api.us-west-2.amazonaws.com/pallas-ai-gen-ai-lambda-func-v4/"
        : "https://39o5scb2l3.execute-api.us-west-2.amazonaws.com/lambdaAWSQV2/";
    scrollToBottomFn(0);

    fetch(url, {
      method: "POST",
      headers: {
        'authorizationToken':`${token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({ query: newMessage.question }),
      body: JSON.stringify({ prompt: newMessage.question }),
      signal: controller.signal,
    })
      .then((response) => {
        console.log(response, "response131::");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Message sent successfully:", data);
        // const responseBody = JSON.parse(data.body);
        // console.log(responseBody, "::0909");
        // const message = responseBody.meesage;
        // newMessage.answer = message;
        // Check which URL was used

        const responseBody = JSON.parse(data.body);
        console.log(responseBody, "146::");
        if (
          url ===
          "https://39o5scb2l3.execute-api.us-west-2.amazonaws.com/lambdaAWSQV2/"
        ) {
          // Handle specific new structure with multiple chunks of data
          const meesage = responseBody.meesage;
          let message = "";
          if (meesage) {
            for (const key in meesage) {
              if (meesage[key].answer) {
                message += meesage[key].answer + " ";
              }
            }
            message = message.trim() || "No message found";
          } else {
            message = "No message found";
          }
          newMessage.answer = {
            answer: responseBody.meesage,
          };
        } else {
          const responseBody = JSON.parse(data.body);
          const message = responseBody.message;
          newMessage.answer = {
            answer: message,
          };
        }
        newMessage.answer.contents_list = responseBody.contents_list;
        if (isFirstMesssge) {
          getConversations()
            .then((data) => {
              const conv = data?.find(
                (conv) => conv.conversation_name === newMessage.question
              );
              if (conv.conversation_id) {
                setActiveConversation(conv);
                uploadConversationMessage({
                  session_token: accessToken,
                  conversation_id: conv.conversation_id,
                  newMessage,
                });
              }
            })
            .catch((err) => {
              console.log("SEND_CONV_ERR::", err.message);
            });
        } else {
          uploadConversationMessage({
            session_token: accessToken,
            conversation_id: activeConversation.conversation_id,
            newMessage,
          });
        }
        getConversations()
          .then((data) => {
            const conv = data.find(
              (conv) => conv.conversation_name === newMessage.input
            );
            console.log("SEND_COVO::", conv, data, newMessage);
          })
          .catch((err) => console.log("SEND_CONV_ERR::", err.message));
        // console.log(message, "5252::");
      })
      .catch((error) => {
        if(error.response && (error.response.status===401 || error.response.status===403)){
          let errorMessage='';
          if(error.response.status===401){
            errorMessage='Please login again'
          }else if(error.response.status===403){
            errorMessage='You do not have permission to access this resource'
          }
          window.dispatchEvent(new CustomEvent('tokenExpired', {detail:{errorMessage}}));
        }
        console.error("There was a problem sending the message:", error);
        setMessages([...messages]);
      })
      .finally(() => {
        setIsMessageLoading(false);

        setStopGenerating(false);
      });
    console.log("IS_FIRST:::", isFirstMesssge);
    if (isFirstMesssge) {
      const postpayload = {
        body: {
          conversation_name: question,
          session_token: accessToken,
        },
      };

      const postapiEndpoint =
        "https://2g1t71hr5l.execute-api.ap-southeast-2.amazonaws.com/llm_post_conversation/";
      axiosInstance
        .post(postapiEndpoint, postpayload, { signal: controller.signal })
        .then((response) => {
          console.log("POST request successful:", response.data);
          const { data } = response;
          if (data.errorMessage) {
            throw new Error(data.errorMessage);
          }
        })
        .catch((error) => {
          console.error("Error in POST request:", error);
          setError(error.message);
        });

      setIsFirstMessage(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      sendMessage();
    }
  };

  const getConversationMessages = async (
    id,
    page_number = 1,
    isUpate = false
  ) => {
    try {
      if (isUpate) {
        setIsPrevMessagesLoading(true);
      } else {
        setIsMessagesLoading(true);
      }
      const response = await getChatConversation(id, page_number);
      console.log("response::::", response);
      const { conversations, isVersion2, error } = response;
      if (error) {
        setHasPrevMessages(false);
        return;
      }
      if (isVersion2) {
        setSelectedModal("VERSION_2");
      } else {
        setSelectedModal("VERSION_1");
      }
      if (isUpate) {
        const chats = conversations.reverse();
        setMessages([...chats, ...messages]);
        const el = document.querySelector(inifinteWrapperClassName);
        scrollToBottomFn(el.scrollHeight);
      } else {
        setMessages(conversations.reverse());
        scrollToBottomFn(0);
      }
      setHasPrevMessages(true);
      setIsFirstMessage(false);
    } catch (err) {
      setHasPrevMessages(false);
      console.log("CONVO_MESSAGES_ERR::", err);
    } finally {
      setIsMessagesLoading(false);
      setIsPrevMessagesLoading(false);
    }
  };
  const handleConversationClick = (convo) => {
    setPrevMszPageNumber(1);
    setActiveConversation(convo);
    getConversationMessages(convo.conversation_id);
  };
  const handleNewChatBtnClick = () => {
    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
  };
  const handleCoderCompanionGptClick = () => {
    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
    setSelectedModal("VERSION_2");
  };
  const handleCoderCompanionClick = () => {
    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
    setSelectedModal("VERSION_1");
  };
  const handleStopGenerating = () => {
    abortController.abort();
    const newMessages = messages.filter(
      (message) => message.question !== messageInput
    );
    setMessages(newMessages);
    setStopGenerating(false);
  };
  const handleMessageClick = (title) => {
    setMessageInput(title);
    sendMessage(title);
  };

  const fetchArchivedConversations = async () => {
    try {
      const response = await fetchArchiveChat();
      setArchivedChats(response);
    } catch (err) {
      console.error("Error in Archived request:", err.message);
    }
  };
  const updateLikeState = ({
    session_token,
    message_id,
    is_liked,
    user_comment_on_message_response,
  }) => {
    updateMessageLikeStatus({
      session_token,
      message_id,
      is_liked,
      user_comment_on_message_response,
    }).then(() => {
      const updateMessages = messages.map((message) => {
        if (message.message_id === message_id) {
          return { ...message, is_liked };
        }
        return message;
      });
      setMessages(updateMessages);
    });
  };
  console.log("prev_page_num::outtt", prevMszPageNumber);
  const getPrevMessages = () => {
    console.log("prev_page_num::", prevMszPageNumber);
    setPrevMszPageNumber((prev) => prev + 1);
    getConversationMessages(
      activeConversation.conversation_id,
      prevMszPageNumber + 1,
      true
    );
  };

  console.log("MESSAGES_LIST::", messages);
  return (
    <>
      <Header
        setError={setError}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        getConversationsFn={getConversations}
        archivedChats={archivedChats}
        fetchArchivedConversations={fetchArchivedConversations}
        hasMoreConversationsVal={hasMoreConversations}
        currentPageNum={currentPage}
      />

      <div
        className={`main-page-container ${
          mode === "DARK" ? "dark-container" : " light-container"
        }`}
      >
        {mode === "DARK" && (
          <Sidebar
            conversations={conversations}
            handleClick={handleConversationClick}
            handleNewChatBtnClick={handleNewChatBtnClick}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            getConversationsFn={getConversations}
            fetchArchivedConversations={fetchArchivedConversations}
            setMessages={setMessages}
            isLoading={isConversationsLoading}
            hasMoreConversationsVal={hasMoreConversations}
            currentPageNum={currentPage}
          />
        )}
        <div className="page-wrapper">
          <div className="chat-space-wrapper">
            <div className="coder-toggle-button">
              <span
                className={selectedModal === "VERSION_1" ? "active" : ""}
                onClick={handleCoderCompanionClick}
              >
                Ai Companion V1
              </span>
              <span
                className={selectedModal === "VERSION_2" ? "active" : ""}
                onClick={handleCoderCompanionGptClick}
              >
                Ai Companion V2
              </span>
            </div>
            {/* <div className="gptLogo">
              <img src={CompanionLogo} alt="CompanionLogo" />
            </div> */}
          </div>
          <div className="intial-message-card-wrapper">
            <div
              className={`message-wrapper ${
                messages.length === 0 ? "initial-messages" : ""
              }`}
              ref={messagesRef}
            >
              {isMessagesLoading ? (
                <Spinner />
              ) : (
                <>
                  {messages.length === 0 && (
                    <InitialMessageSection
                      handleMessageClick={handleMessageClick}
                    />
                  )}
                  <InfiniteScroll
                    isTopScroll={true}
                    className="message-wrapper chat-infinte-scroll"
                    loadMore={() => getPrevMessages()}
                    hasData={hasPrevMessages}
                    isLoading={isPrevMessagesLoading}
                  >
                    {messages.map((message) => (
                      <MessageCard
                        key={message.message_id}
                        message={message}
                        updateLikeState={updateLikeState}
                      />
                    ))}
                    {isMessageLoading && <MessageLoader />}
                  </InfiniteScroll>
                  
                </>
              )}

              <div className="search-wrapper">
                {stopGenerating && (
                  <p onClick={handleStopGenerating} className="stop-generating">
                    <img src={StopGenerating} alt="CompanionLogo" />{" "}
                    <span>Stop Generating</span>
                  </p>
                )}
                <div>
                  <input
                    className="search-input"
                    type="text"
                    placeholder="Message AI Companion"
                    value={messageInput}
                    onChange={handleMessageInputChange}
                    onKeyDown={handleKeyPress}
                  />
                </div>
                <div className="input-button" onClick={() => sendMessage()}>
                  <img src={SendIcon} alt="sendicon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChatPage;
